import { PureComponent } from 'react';

import {
  ChunkEntry,
  DiffInlineRenderProp,
  Line,
  LineAnnotation,
  OnAddComment,
  OnShowMoreLines,
} from '../../common/types';

import ChunkContainer from './chunk-container';
import { DiffSide } from './diff-content';

export type ChunkLoaderProps = {
  activePermalink?: string;
  filePath?: string;
  inlineContent?: DiffInlineRenderProp;
  isSideBySide: boolean;
  chunk: ChunkEntry;
  chunkIndex: number;
  onAddComment?: OnAddComment;
  onPermalinkClick?: (permalink: string) => void;
  onShowMoreLines: OnShowMoreLines;
  showPermalinks: boolean;
  fileAnnotations?: LineAnnotation[];
  isPrAnnotationsEnabled?: boolean;
  isFirstChunk: boolean;
  isLastChunk: boolean;
  isMultiChunkExpansionInDiffEnabled?: boolean;
  isDiffSearchEnabled?: boolean;
  isSyntaxHighlightingEnabled?: boolean;
  shouldHighlightDiffLine?: (diffLine: Line) => boolean;
  getOnSelectionStart?: (
    diffSide: DiffSide
  ) => (chunkIndex: number, lineIndex: number) => void;
  getOnSelectionMove?: (
    diffSide: DiffSide
  ) => (
    chunkIndex: number,
    lineIndex: number,
    currentChunk: ChunkEntry,
    sideBySideChunks?: { before: ChunkEntry; after: ChunkEntry }
  ) => void;
  onSelectionEnd?: () => void;
  shouldHighlightLineDivider?: (line: Line) => boolean;
  isMultilineSelecting?: boolean;
  selectionChunkIndex?: number;
  selectionStartLineIndex?: number;
  shouldShowMLCOnboarding?: boolean;
};

export type ChunkLoaderState = {
  chunk: ChunkEntry;
};

// TODO: Replace usage of unsafe lifecycle methods
// eslint-disable-next-line react/no-unsafe
export default class ChunkLoader extends PureComponent<
  ChunkLoaderProps,
  ChunkLoaderState
> {
  state = {
    chunk: this.props.chunk,
  };

  // eslint-disable-next-line react/no-unsafe
  UNSAFE_componentWillReceiveProps(nextProps: ChunkLoaderProps): void {
    if (nextProps.chunk !== this.props.chunk) {
      this.setState({ chunk: nextProps.chunk });
    }
  }

  handleShowMoreLines = (
    isShiftClicked: boolean,
    shouldExpandDown: boolean
  ) => {
    const { chunkIndex, onShowMoreLines } = this.props;
    const expanderIndex = chunkIndex;
    const { chunk } = this.state;
    const { extra } = chunk;
    const newChunk = {
      ...chunk,
      extra: {
        ...extra,
        isLoadingAbove: !shouldExpandDown,
        isLoadingBelow: shouldExpandDown,
      },
    };

    this.setState({ chunk: newChunk });
    onShowMoreLines(expanderIndex, isShiftClicked, shouldExpandDown);
  };

  render() {
    const {
      activePermalink,
      isSideBySide,
      filePath,
      inlineContent,
      onAddComment,
      onPermalinkClick,
      showPermalinks,
      fileAnnotations,
      isPrAnnotationsEnabled,
      isFirstChunk,
      isLastChunk,
      isSyntaxHighlightingEnabled,
      isMultiChunkExpansionInDiffEnabled,
      isDiffSearchEnabled,
      shouldHighlightDiffLine,
      chunkIndex,
      getOnSelectionStart,
      getOnSelectionMove,
      onSelectionEnd,
      shouldHighlightLineDivider,
      isMultilineSelecting,
      selectionChunkIndex,
      selectionStartLineIndex,
      shouldShowMLCOnboarding,
    } = this.props;

    const { chunk } = this.state;

    return (
      <ChunkContainer
        activePermalink={activePermalink}
        filePath={filePath}
        onShowMoreLines={this.handleShowMoreLines}
        chunk={chunk}
        chunkIndex={chunkIndex}
        inlineContent={inlineContent}
        isSideBySide={isSideBySide}
        onAddComment={onAddComment}
        onPermalinkClick={onPermalinkClick}
        showPermalinks={showPermalinks}
        fileAnnotations={fileAnnotations}
        isPrAnnotationsEnabled={isPrAnnotationsEnabled}
        isFirstChunk={isFirstChunk}
        isLastChunk={isLastChunk}
        isSyntaxHighlightingEnabled={isSyntaxHighlightingEnabled}
        isMultiChunkExpansionInDiffEnabled={isMultiChunkExpansionInDiffEnabled}
        isDiffSearchEnabled={isDiffSearchEnabled}
        shouldHighlightDiffLine={shouldHighlightDiffLine}
        getOnSelectionStart={getOnSelectionStart}
        getOnSelectionMove={getOnSelectionMove}
        onSelectionEnd={onSelectionEnd}
        shouldHighlightLineDivider={shouldHighlightLineDivider}
        isMultilineSelecting={isMultilineSelecting}
        selectionChunkIndex={selectionChunkIndex}
        selectionStartLineIndex={selectionStartLineIndex}
        shouldShowMLCOnboarding={shouldShowMLCOnboarding}
      />
    );
  }
}
